import React from 'react'
import { styled } from '@mui/material'

const Wrapper = styled('div')(({ theme }) => ({
    position: 'absolute',
    bottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    width: '160px',
    left: 'calc((100% - 160px) / 2)',
    [theme.breakpoints.up('md')]: {
        bottom: '40px',
        width: '200px',
        left: 'calc((100% - 200px) / 2)',
    },
}))

const Image = styled('img')({
    width: '100%',
})

const Attribution = styled('p')({
    margin: 0,
    fontSize: '8px',
    lineHeight: 1.4,
    color: 'rgba(255, 255, 255, 0.55)',
    textAlign: 'center',
    fontFamily:
        '-apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif',
})

function PoweredBy() {
    return (
        <Wrapper>
            <Image src="/Powered-by-PixlBank-Logo.png" alt="powered by" />
            <Attribution>
                XR Engine © 2026 Niantic Spatial, Inc.{' '}
                <a
                    href="https://github.com/8thwall/engine/blob/main/LICENSE"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'inherit', textDecoration: 'underline' }}
                >
                    License
                </a>
            </Attribution>
        </Wrapper>
    )
}

export { PoweredBy }